import React from "react";

interface SearchSectionProps {
  title: string;
  children: React.ReactNode;
}

export function SearchSection({ title, children }: SearchSectionProps) {
  return (
    <div>
      <h3 className="mb-2 px-2 font-semibold text-gray-500 text-xs uppercase tracking-wide">
        {title}
      </h3>
      <div className="space-y-1">{children}</div>
    </div>
  );
}
